(function () {
  'use strict';

  var store = window.WmpStore;
  var router = window.WmpRouter;

  /* Placeholder thumbnail SVG for accessories */
  var THUMB_SVG = '<svg width="60" height="60" viewBox="0 0 60 60" fill="none"><rect x="8" y="14" width="44" height="32" rx="4" stroke="currentColor" stroke-width="1.5"/><path d="M18 34l8-8 6 6 4-4 8 8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" opacity="0.4"/></svg>';

  var actionBtn = null;
  var MAX_ACCESSORIES = 4;

  function calcAccessoriesTotal(selectedKeys) {
    var config = window.WmpProductsConfig;
    var total = 0;
    if (!config) return total;

    for (var i = 0; i < selectedKeys.length; i++) {
      var acc = config.findAccessory(selectedKeys[i]);
      if (acc) total += (acc.priceCents || 0);
    }
    return total;
  }

  /* Vision Club offer card (first card of this step). Everything it shows comes from
     window.VisionClubConfig (theme settings + live membership product); the card is absent when
     the program is off, the country is not eligible, the tier cannot be resolved or the shopper
     is already a member. Selecting it flags state.membership (and counts toward the step's button label); the review step adds the
     membership line with the pair. */
  function visionClubConfig() {
    var cfg = window.VisionClubConfig;
    if (!cfg || !cfg.placementsEnabled || !cfg.available || cfg.isMember || !cfg.placements.rxCard) return null;
    // Non-prescription pairs earn no Vision Club benefit, so no offer either.
    if (store.get('prescriptionType') === 'non-prescription') return null;
    return cfg;
  }

  // Same calculation as the struck prices in the summaries (wmp-app.js), so "Save $X" always matches them.
  function membershipSavingsCents(cfg) {
    var off = window.WmpVisionClubJoin.savingsCents(store.get('pricing'), cfg.joinDiscountPercent);
    return off.frame + off.lenses;
  }

  function renderVisionClubCard(list, cfg) {
    var copy = cfg.copy || {};
    var inCart = !!cfg.inCart;
    var selected = !inCart && !!store.get('membership');
    if (inCart && store.get('membership')) store.set('membership', false);

    var card = document.createElement('div');
    card.className = 'wmp-card wmp-card--separate-controls wmp-card--vision-club';
    if (selected) card.classList.add('wmp-card--selected');
    if (inCart) card.classList.add('wmp-card--vision-club-added');
    card.setAttribute('data-vision-club-rx-card', '');

    var titleText = copy.rxCardTitle || 'Join Vision Club';
    var priceText = (copy.rxCardCta || '[price]/yr').replace('[price]', cfg.priceFormatted || '');

    if (!inCart) {
      var control = document.createElement('button');
      control.className = 'wmp-card__select-control';
      control.setAttribute('type', 'button');
      control.setAttribute('aria-pressed', selected ? 'true' : 'false');
      control.setAttribute('aria-label', titleText + ', ' + priceText);
      control.addEventListener('click', onVisionClubClick);
      card.appendChild(control);
    }

    var iconEl = document.createElement('span');
    iconEl.className = 'wmp-card__icon vision-club-badge';
    iconEl.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.src = cfg.badgeUrl;
    img.alt = '';
    iconEl.appendChild(img);
    card.appendChild(iconEl);

    var content = document.createElement('div');
    content.className = 'wmp-card__content';

    var title = document.createElement('span');
    title.className = 'wmp-card__title';
    title.textContent = titleText.toUpperCase();
    content.appendChild(title);

    var savingsTemplate = copy.rxCardSavings || '';
    if (savingsTemplate && !inCart) {
      var savings = document.createElement('span');
      savings.className = 'wmp-card__savings';
      savings.setAttribute('data-vision-club-savings', '');
      savings.textContent = savingsTemplate.replace('[savings]', store.formatPrice(membershipSavingsCents(cfg)));
      content.appendChild(savings);
    }

    var desc = document.createElement('span');
    desc.className = 'wmp-card__description';
    if (copy.rxCardText) desc.innerHTML = copy.rxCardText;
    var learn = document.createElement('button');
    learn.className = 'vision-club-learn-more';
    learn.setAttribute('type', 'button');
    learn.setAttribute('data-vision-club-learn-more', '');
    learn.setAttribute('data-vision-club-modal-mode', 'continue');
    learn.setAttribute('aria-haspopup', 'dialog');
    learn.textContent = copy.learnMore || 'Learn more';
    desc.appendChild(document.createTextNode(' '));
    desc.appendChild(learn);
    content.appendChild(desc);
    card.appendChild(content);

    var priceEl = document.createElement('span');
    priceEl.className = 'wmp-card__price';
    priceEl.textContent = inCart ? (copy.addedLabel || 'Added') : priceText;
    card.appendChild(priceEl);

    list.appendChild(card);
    return card;
  }

  function onVisionClubClick(e) {
    var control = e.currentTarget;
    var card = control.closest('.wmp-card--vision-club');
    if (!card) return;
    var selected = !card.classList.contains('wmp-card--selected');
    card.classList.toggle('wmp-card--selected', selected);
    control.setAttribute('aria-pressed', selected ? 'true' : 'false');
    store.set('membership', selected);
    var list = card.closest('.wmp-card-list');
    updateButtonText(getSelected(list).length + (selected ? 1 : 0));
  }

  function syncSelectionPricing(list) {
    var selected = list ? getSelected(list) : [];
    store.set('accessories', selected);

    var pricing = store.get('pricing');
    pricing.accessories = calcAccessoriesTotal(selected);
    store.set('pricing', pricing);

    return selected;
  }

  /* Price cell: sale price (red) + struck-through compare-at when on sale,
     otherwise the plain price. Mirrors the lens-package price markup. */
  function renderPrice(priceEl, priceCents, comparePriceCents) {
    priceEl.innerHTML = '';
    if (comparePriceCents && comparePriceCents > priceCents) {
      var sale = document.createElement('span');
      sale.className = 'wmp-card__price--sale';
      sale.textContent = store.formatPrice(priceCents);
      priceEl.appendChild(sale);
      priceEl.appendChild(document.createTextNode(' '));
      var orig = document.createElement('span');
      orig.className = 'wmp-card__price-original';
      orig.textContent = store.formatPrice(comparePriceCents);
      priceEl.appendChild(orig);
    } else {
      priceEl.textContent = store.formatPrice(priceCents);
    }
  }

  function render(container) {
    var currentAccessories = store.get('accessories') || [];

    var config = window.WmpProductsConfig;
    var accessories = config ? config.getAccessories() : [];

    // Heading
    var heading = document.createElement('h2');
    heading.className = 'wmp-flow__step-heading';
    heading.textContent = store.getStepHeading('accessories');
    container.appendChild(heading);

    var vcConfig = visionClubConfig();

    if (!accessories.length && !vcConfig) {
      // No accessories configured and no membership offer — skip the step entirely
      router.advance();
      return;
    }

    // Card list (single-column, horizontal cards — matches Figma)
    var list = document.createElement('div');
    list.className = 'wmp-card-list';

    if (vcConfig) renderVisionClubCard(list, vcConfig);

    for (var i = 0; i < accessories.length; i++) {
      var acc = accessories[i];
      var displayName = (acc.title || acc.key || '').toString().toUpperCase();

      var card = document.createElement('button');
      card.className = 'wmp-card';
      card.setAttribute('type', 'button');
      card.setAttribute('data-key', acc.key);
      card.setAttribute('data-price', String(acc.priceCents));

      if (currentAccessories.indexOf(acc.key) > -1) {
        card.classList.add('wmp-card--selected');
      }

      // Thumbnail — picked image or product featured image (from config), then SVG fallback
      var iconEl = document.createElement('span');
      iconEl.className = 'wmp-card__icon';
      var imgSrc = acc.image || '';
      if (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = displayName;//width:60px;height:60px;
        img.style.cssText = 'object-fit:cover;border-radius:8px;';
        iconEl.appendChild(img);
      } else {
        iconEl.innerHTML = THUMB_SVG;
      }
      card.appendChild(iconEl);

      // Content
      var content = document.createElement('div');
      content.className = 'wmp-card__content';

      var title = document.createElement('span');
      title.className = 'wmp-card__title';
      title.textContent = displayName;
      content.appendChild(title);

      if (acc.subtitle) {
        var desc = document.createElement('span');
        desc.className = 'wmp-card__description';
        desc.textContent = acc.subtitle;
        content.appendChild(desc);
      }

      card.appendChild(content);

      // Price (right-aligned) — sale-aware
      var priceEl = document.createElement('span');
      priceEl.className = 'wmp-card__price';
      renderPrice(priceEl, acc.priceCents, acc.comparePriceCents);
      card.appendChild(priceEl);

      card.addEventListener('click', onCardClick);
      list.appendChild(card);
    }

    container.appendChild(list);

    // Keep sidebar/mobile subtotal in sync when re-entering this step.
    syncSelectionPricing(list);

    // Action button
    actionBtn = document.createElement('button');
    actionBtn.className = 'wmp-btn wmp-btn--primary wmp-btn--xl wmp-btn--full';
    actionBtn.setAttribute('type', 'button');
    actionBtn.style.marginTop = '24px';
    updateButtonText(currentAccessories.length + (vcConfig && store.get('membership') ? 1 : 0));
    actionBtn.addEventListener('click', onContinue);
    container.appendChild(actionBtn);
  }

  function onCardClick(e) {
    var card = e.currentTarget;
    var list = card.closest('.wmp-card-list');

    // Cap selections at MAX_ACCESSORIES. Selecting beyond the cap is a no-op;
    // deselecting an already-selected card is always allowed.
    if (!card.classList.contains('wmp-card--selected') &&
        getSelected(list).length >= MAX_ACCESSORIES) {
      return;
    }

    card.classList.toggle('wmp-card--selected');
    var selected = syncSelectionPricing(list);
    updateButtonText(selected.length + (store.get('membership') ? 1 : 0));
  }

  function getSelected(list) {
    var cards = list.querySelectorAll('.wmp-card--selected:not(.wmp-card--vision-club)');
    var keys = [];
    for (var i = 0; i < cards.length; i++) {
      keys.push(cards[i].getAttribute('data-key'));
    }
    return keys;
  }

  function updateButtonText(count) {
    if (!actionBtn) return;
    actionBtn.textContent = count > 0 ? 'CONTINUE' : 'NO, THANKS';
  }

  function onContinue() {
    var list = document.querySelector('.wmp-card-list');
    syncSelectionPricing(list);

    router.advance();
  }

  function destroy() {
    actionBtn = null;
  }

  window.WmpSteps = window.WmpSteps || {};
  window.WmpSteps['accessories'] = {
    render: render,
    destroy: destroy,
    onContinue: onContinue
  };
})();
